<template>
  <!-- eslint-disable max-len vue/max-len -->
  <section class="other-school-seo">
    <div class="other-school-seo__info">
      <div class="other-school-seo__info_person">
        <img
          src="/v2/school-new/other-pages/seo/olga.png"
          alt="olga"
        >
        <p>
          <span>Ольга Саковцева</span>
          рассказывает директор школьного университета «Синергия»
        </p>
      </div>
      <h3>все,&nbsp;что нужно знать о&nbsp;{{ pageTypeText }} обучении</h3>
      <h6>
        не&nbsp;нашли ответа на&nbsp;ваш&nbsp;вопрос?
        <span>задайте его&nbsp;специалисту из&nbsp;отдела&nbsp;заботы</span>
      </h6>
      <a
        :href="$telegramBotLink($route)"
        target="_blank"
      >
        <span>задать вопрос</span>
        <img
          src="/v2/school-university/faq/tg.svg"
          alt="telegram"
          loading="lazy"
        >
      </a>
    </div>

    <div
      v-if="$route.name === 'online-school-zaochnoe-obuchenie'"
      class="other-school-seo__text"
    >
      <p>
        Заочная школа — это форма обучения, при которой ученики самостоятельно изучают материал и выполняют задания, а затем отправляют их на проверку преподавателю. При этом процесс обучения проходит без регулярного посещения занятий в классе или с минимальным личным присутствием.
      </p>
      <p>
        Заочное обучение позволяет получать образование в удобном темпе и формате, сохраняя при этом качество получаемых знаний. Для получения оценок за год ученику необходимо сдать итоговые аттестации по всем предметам в указанный срок.
      </p>
      <span>Преимущества заочного обучения:</span>
      <ol>
        <li>Индивидуальный темп обучения.&nbsp;Вы можете сами выбирать, сколько времени уделять изучению материала и когда выполнять задания.</li>
        <li>Гибкий график.&nbsp;Вам не нужно подстраиваться под расписание занятий, вы можете учиться в любое удобное время.</li>
        <li>Экономия времени и денег.&nbsp;Заочное обучение часто дешевле очного и позволяет сэкономить время на дорогу до учебного заведения.</li>
        <li>Самостоятельность и ответственность.&nbsp;Вы учитесь самостоятельно, что развивает навыки самоорганизации и ответственности.</li>
        <li>Возможность совмещать с&nbsp;работой или другой деятельностью.&nbsp;Заочное образование подходит тем, кто хочет получить новые знания и&nbsp;навыки, но&nbsp;не&nbsp;может посещать занятия очно из-за занятости.</li>
        <li>Развивает стрессоустойчивость:&nbsp;решение задач по программированию учит ребенка находить выход из сложных ситуаций и не сдаваться при возникновении трудностей.</li>
        <li>Развитие навыков самообразования.Заочное обучение требует самостоятельного изучения материала, что способствует развитию навыков поиска информации, анализа и критического мышления.</li>
      </ol>

      <span>Чтобы поступить на заочную форму обучения, необходимо выполнить следующие шаги:</span>

      <ol>
        <li>Оставьте заявку&nbsp;на нашем сайте для консультации с вашим личным куратором. Вам подробно расскажу про школу и объяснят детально все следующие шаги.</li>
        <li>Подайте заявление онлайн на&nbsp;зачисление&nbsp;на&nbsp;заочное отделение. Вам потребуются документы, подтверждающие вашу личность и&nbsp;личность ребёнка.</li>
        <li>Заключите договор и&nbsp;оплатите обучение.&nbsp;В&nbsp;нашей школе вы&nbsp;можете оплатить заочное обучение с&nbsp;помощью материнского капитала, в&nbsp;рассрочку или Сплитом от&nbsp;Яндекса.</li>
        <li>Перейдите на платформе и приступайте к обучению.&nbsp;На нашей платформе есть все необходимые материалы для самостоятельного обучения по всем школьным предметам: видео, тренажеры, интерактивные занятия, конспекты и лекции.</li>
      </ol>
    </div>

    <div
      v-else-if="$route.name === 'online-school-vechernee-obuchenie'"
      class="other-school-seo__text"
    >
      <p>
        Вечернее образование&nbsp;— это форма обучения, которая предназначена для людей, которым сложно посещать занятия в&nbsp;дневное время. Онлайн-школа «Синергия» предоставляет возможность получать знания и&nbsp;навыки, сочетая учебу с&nbsp;другими обязанностями, такими как работа или семейные дела.
      </p>
      <p>
        Образовательная платформа онлайн-школы «Синергия»&nbsp;— это пространство, где ученики получают всё необходимое для успешного обучения. Здесь они могут общаться с&nbsp;преподавателями, изучать 1000 бесплатных курсов и&nbsp;материалов. А&nbsp;главное&nbsp;— могут самостоятельно планировать свой график учебы. Благодаря записям занятий, которые доступны в&nbsp;любое удобное время, ученики могут повторить материал или изучить его более детально.
      </p>
      <span>Преимущества Онлайн-школы «Синергия»:</span>
      <ol>
        <li>Гибкость расписания.&nbsp;Онлайн-школа позволяет учащимся распределять свое время, совмещая учебу с рабочими или другими обязанностями.</li>
        <li>Доступность для разных возрастов.&nbsp;Онлайн-школа «Синергия» открыта для всех, независимо от возраста. Это позволяет каждому получить знания и навыки, когда это удобно.</li>
        <li>Приобретение новых навыков и компетенций.&nbsp;В онлайн-школе «Синергия» открываются новые курсы по разным направлениям, такие как: IT-класс, медиа класс, кибер класс и другие. Это позволяет учащимся улучшить свои карьерные возможности и повысить квалификацию.</li>
        <li>Стимулирование саморазвития.&nbsp;Обучение в онлайн-школе способствует развитию навыков самоорганизации и управлению временем, что является важными качествами в условиях современного рынка труда.</li>
        <li>Экономия времени и ресурсов.&nbsp;Обучение в онлайн-школе «Синергия» может сократить время на дорогу в школу и обратно, а также уменьшить расходы на учебные материалы и школьные принадлежности.</li>
      </ol>
    </div>

    <div
      v-else
      class="other-school-seo__text"
    >
      <p>
        Семейное обучение&nbsp;— это форма обучения, при которой дети учатся дома, а&nbsp;не&nbsp;в&nbsp;школе. За&nbsp;их&nbsp;обучением следят родители или опекуны. В&nbsp;онлайн-школе «Синергия» обучение организовано по&nbsp;определённой структуре. У&nbsp;нас есть учебные планы, расписание занятий и&nbsp;доступ к&nbsp;преподавателям. Наши онлайн-курсы чётко структурированы и&nbsp;помогают постепенно достигать поставленных образовательных целей. В&nbsp;процессе обучения ученики получают обратную связь, участвуют в&nbsp;обсуждениях и&nbsp;задают вопросы преподавателям. Это делает обучение более интерактивным и&nbsp;эффективным.
      </p>
      <p>
        Социализация играет важную роль в&nbsp;семейном обучении. Родители могут помочь своим детям развивать социальные навыки, организуя их&nbsp;участие в&nbsp;различных групповых мероприятиях. Это могут быть кружки, спортивные секции или другие виды деятельности, где дети смогут общаться с&nbsp;другими сверстниками. В&nbsp;онлайн-школе «Синергия» мы&nbsp;знаем, как важно для наших учеников общение со&nbsp;сверстниками. Поэтому мы&nbsp;не&nbsp;только даём знания, но&nbsp;и&nbsp;организуем разнообразные внеклассные мероприятия. Это могут быть интересные клубы по&nbsp;увлечениям, лекции от&nbsp;экспертов, онлайн&nbsp;— и&nbsp;офлайн-экскурсии. А&nbsp;после завершения обучения мы&nbsp;проводим выпускной. Мы&nbsp;стремимся создать условия для живого общения и&nbsp;развития социальных навыков наших учеников, чтобы они могли успешно адаптироваться в&nbsp;обществе.
      </p>

      <span>Преимущества семейного образования:</span>
      <ol>
        <li>
          Гибкость расписания.&nbsp;Онлайн-школа «Синергия» дает вам свободу в выборе времени для занятий. Вы можете смотреть записи уроков, когда вам удобно, и планировать свой день так, чтобы в нём нашлось место для спорта, творчества и других дел.
        </li>
        <li>
          Улучшение взаимодействия.&nbsp;Обучаясь дома, дети могут чаще общаться с родителями и другими членами семьи, что способствует укреплению семейных связей и эмоциональной поддержки. Это может быть особенно полезно для развития уверенности и самооценки.
        </li>
        <li>
          Разнообразие методов обучения.&nbsp;В семейном обучении родители могут применять разнообразные методы и подходы, такие как практические занятия, проекты, экскурсии. Это делает процесс обучения более увлекательным и интересным. На платформе онлайн-школы «Синергия» ученики могут найти более 10 000 бесплатных интерактивных тренажёров и 1000 учебных материалов и курсов, которые помогут им лучше усвоить материал.
        </li>
        <li>
          Меньше стресса и давления.&nbsp;Дети, обучающиеся на дому, реже сталкиваются с буллингом и социальным давлением, часто характерными для традиционных школ.
        </li>
        <li>
          Глубокое усвоение материала.&nbsp;Благодаря индивидуальному подходу и гибкому расписанию, дети могут более глубоко осваивать изучаемые темы, проходя их в комфортном для себя темпе.
        </li>
        <li>
          Экономия времени и ресурсов.&nbsp;Обучение в онлайн-школе «Синергия» может сократить время на дорогу в школу и обратно, а также уменьшить расходы на учебные материалы и школьные принадлежности.
        </li>
        <li>
          Развитие ответственности и самостоятельности.&nbsp;Учёба в онлайн-школе помогает детям стать более ответственными за свое обучение. Они сами планируют занятия и выполняют домашние задания. Это способствует развитию навыков управления временем и организации. Ну, а если ребенку понадобится помощь с домашкой или другими учебными задачами, наши кураторы всегда готовы вам помочь.
        </li>
      </ol>
    </div>
  </section>
</template>

<script>
export default {
  name: 'OtherSchoolSeo',
  computed: {
    pageTypeText() {
      if (this.$route.name === 'online-school-zaochnoe-obuchenie') return 'заочном';
      if (this.$route.name === 'online-school-vechernee-obuchenie') return 'вечернем';
      return 'семейном';
    },
  },
};
</script>

<style scoped lang="scss">

.other-school-seo {
  padding: calc(var(--scale) * 40);
  background-color: #FFFFFF;
  border-radius: calc(var(--scale) * 60);
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  position: relative;

  @include media-down($size-tablet) {
    padding: calc(var(--scale) * 16);
    border-radius: calc(var(--scale) * 32);
  }

  @include media-down($size-tablet) {
    flex-direction: column-reverse;
    padding-top: calc(var(--scale) * 198);
    gap: calc(var(--scale) * 40);
  }

  &__info {
    width: calc(var(--scale) * 560);
    flex-shrink: 0;

    @include media-down($size-tablet) {
      width: 33.4rem;
    }

    @include media-down($size-mobile) {
      width: 100%;
    }

    &_person {
      margin-bottom: calc(var(--scale) * 20);
      display: flex;
      align-items: flex-start;
      gap: calc(var(--scale) * 20);

      @include media-down($size-mobile) {
        position: absolute;
        left: calc(var(--scale) * 16);
        top: calc(var(--scale) * 20);
      }

      img {
        width: calc(var(--scale) * 80);
        height: calc(var(--scale) * 80);
        border-radius: calc(var(--scale) * 20);

        @include media-down($size-tablet) {
          width: calc(var(--scale) * 64);
          height: calc(var(--scale) * 64);
        }
      }

      p {
        max-width: calc(var(--scale) * 300);
        font-weight: 500;
        font-size: calc(var(--scale) * 16);
        line-height: 120%;
        color: #02120F;

        @include media-down($size-tablet) {
          font-size: calc(var(--scale) * 14);
        }

        span {
          display: block;
          font-size: calc(var(--scale) * 26);

          @include media-down($size-tablet) {
            font-size: calc(var(--scale) * 20);
          }
        }
      }
    }

    h3 {
      margin-bottom: 1.25rem;

      font-style: normal;
      font-weight: 500;
      font-size: calc(var(--scale) * 48);
      line-height: 110%;
      letter-spacing: -0.02em;
      color: #02120F;

      @include media-down($size-tablet) {
        margin-bottom: calc(var(--scale) * 20);
        font-size: calc(var(--scale) * 28);
        line-height: 110%;
        letter-spacing: -0.04em;
      }

      @include media-down($size-mobile) {
        position: absolute;
        left: calc(var(--scale) * 16);
        top: calc(var(--scale) * 104);
      }
    }

    h6 {
      margin-bottom: 1.25rem;

      font-style: normal;
      font-weight: 500;
      font-size: 2rem;
      line-height: 110%;
      color: #02120F;

      @include media-down($size-tablet) {
        font-size: 1.8rem;
        margin-bottom: calc(var(--scale) * 20);
      }

      span {
        color: #A7ABAC;

        @include media-down($size-mobile) {
          display: block;
          padding-top: calc(var(--scale) * 10);
        }
      }
    }

    a {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0.5rem;

      width: calc(var(--scale) * 299);
      height: calc(var(--scale) * 72);

      background-color: #2193CC;
      border-radius: calc(var(--scale) * 24);
      transition: 200ms;

      @include media-down($size-tablet) {
        width: 24rem;
        height: 7.2rem;
        border-radius: 2.4rem;
      }

      @include media-down($size-mobile) {
        margin-top: 2rem;
        width: 100%;
      }

      @media (hover: hover) {
        &:hover {
          background-color: #1A84B9;
        }
      }

      span {
        font-weight: 500;
        font-size: calc(var(--scale) * 26);
        line-height: 120%;
        color: #FFFFFF;

        @include media-down($size-tablet) {
          font-size: 2rem;
          line-height: 110%;
          letter-spacing: -0.02em;
        }
      }

      img {
        width: calc(var(--scale) * 44);
      }
    }
  }

  &__text {
    width: calc(var(--scale) * 870);

    @include media-down($size-tablet) {
      width: calc(var(--scale) * 334);
    }

    p,
    span,
    li {
      font-weight: 400;
      font-size: calc(var(--scale) * 20);
      line-height: 130%;
      color: #02120F;

      @include media-down($size-tablet) {
        font-size: calc(var(--scale) * 12);
      }
    }

    p {
      margin-bottom: 1.2em;
    }

    ol {
      margin-block: 0.6em;
      list-style-type: disc;
      padding-left: 1.5em;
    }
  }
}

</style>
